var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgReference = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.54 6h12.92c.806 0 1.58.316 2.15.879S21.5 8.204 21.5 9v6a2.98 2.98 0 0 1-.89 2.121 3.06 3.06 0 0 1-2.15.879H5.54a3.06 3.06 0 0 1-2.15-.879A2.98 2.98 0 0 1 2.5 15V9c0-.796.32-1.559.89-2.121A3.06 3.06 0 0 1 5.54 6m1.184 3.572v4.678h.937V12.4h.561l.964 1.85h1.081l-1.156-2.066a2 2 0 0 0 .319-.212q.146-.119.249-.28a1.4 1.4 0 0 0 .161-.375 2 2 0 0 0 .058-.503q0-.39-.154-.655a1.2 1.2 0 0 0-.41-.418 1.8 1.8 0 0 0-.582-.219 3.4 3.4 0 0 0-.66-.065q-.334.003-.666.027-.353.03-.702.088m1.436.709q.37 0 .561.172a.6.6 0 0 1 .192.476q0 .405-.246.58-.248.176-.636.176h-.37v-1.37q.106-.025.216-.027a6 6 0 0 1 .283-.007m2.723-.756v4.725h3.174v-.823H11.82v-1.155h2.031v-.823H11.82v-1.1h2.202v-.824zm4.2 0v4.725h.937v-1.91h1.949v-.824h-1.95v-1.168h2.1v-.823z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReference);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reference.b3bcb50d.svg";